module.exports = __webpack_public_path__ + "static/media/09PerformancePhotos.19c77085.jpeg";